// Thin fetch wrappers used by every API call in the app.
const API = '';

// Builds the Error thrown on a non-ok response. err.message is always the
// human-readable string (data.message when the server sent one, otherwise
// the machine error code, otherwise a generic fallback) — callers that just
// do `alert(e.message)` get a sane string instead of a raw code like
// "upload_failed". err.data / err.status still carry the full payload for
// callers that want to branch on the specific error code.
function apiError(res, data) {
  const err = new Error((data && data.message) || (data && data.error) || 'request_failed');
  err.status = res.status;
  err.data = data;
  return err;
}

export async function apiGet(path) {
  const res = await fetch(API + path, { credentials: 'include' });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw apiError(res, data);
  }
  return res.json();
}

export async function apiPost(path, body) {
  const res = await fetch(API + path, {
    method: 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {})
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw apiError(res, data);
  return data;
}

export async function apiPatch(path, body) {
  const res = await fetch(API + path, {
    method: 'PATCH', credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {})
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw apiError(res, data);
  return data;
}

export async function apiDelete(path) {
  const res = await fetch(API + path, { method: 'DELETE', credentials: 'include' });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw apiError(res, data);
  return data;
}
